module.exports = __webpack_public_path__ + "static_wap/img/image.bc89caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/image.png
// module id = 0X6e
// module chunks = 1